import React, { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FormControl, MenuItem } from "@mui/material";
import { createUserSetting } from 'api';
import { QUERY_KEYS } from 'consts';
import { useNotify } from 'hooks';
import { ILoggedUserData } from 'types';
import { EsgDropDownIcon } from 'assets';
import { COLORS, TYPOGRAPHY_COMMON_STYLES } from 'components';

import { dateFormats } from './consts';

import { CustomSmallOutlinedInput } from './modal';
import { CustomSelect } from './custom-select';

export const DateFormatSelector = ({ loggedUserData }: { loggedUserData: ILoggedUserData }) => {
  const notify = useNotify();
  const queryClient = useQueryClient();

  const [selectedFormat, setSelectedFormat] = useState<string>(loggedUserData.dateFormat || dateFormats[0]);

  const { mutateAsync: createDateSetting } = useMutation(createUserSetting);

  const handleFormatChange = (event: any) => {
    setSelectedFormat(event.target.value);
    if (event.target.value) {
      createDateSetting({ dateFormat: event.target.value }, {
        onError: () =>
          notify.error("Some error has happen while updating date format"),
        onSuccess: () => {
          notify.success("Successfully updated date format!");
          queryClient.invalidateQueries([QUERY_KEYS.USER_SETTINGS]);
        }
      });
    }
  };

  return (
    <FormControl fullWidth variant="outlined">
      <CustomSelect
        value={selectedFormat}
        onChange={handleFormatChange}
        input={<CustomSmallOutlinedInput />}
        IconComponent={EsgDropDownIcon}
        sx={{ width: "240px" }}
        displayEmpty
      >
        {dateFormats.map((format) => (
          <MenuItem
            sx={{
              fontWeight: TYPOGRAPHY_COMMON_STYLES.fontWeightSemiBold,
              fontSize: 14,
              lineHeight: "18px",
              color: '#90959E',
              '&:hover': {
                backgroundColor: '#F6F8FA',
                borderRadius: 5,
                color: COLORS.Romance,
              },
              '&.Mui-selected': {
                backgroundColor: '#F6F8FA',
                borderRadius: 5,
                color: COLORS.Romance,
              },
            }}
            key={format}
            value={format}
          >
            {format}
          </MenuItem>
        ))}
      </CustomSelect>
    </FormControl>
  )
};
